import type { TypographyVariantsOptions } from "@mui/material";
import type { Components } from "@mui/material/styles";

export const typography: TypographyVariantsOptions = {
  fontFamily: "var(--base-font-family)",
  fontSize: 16,
  htmlFontSize: 16,
  h1: {
    fontSize: "var(--font-size-h1)",
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: 0.02,
  },
  h2: {
    fontSize: "var(--font-size-h2)",
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: 0.02,
  },
  h3: {
    fontSize: "var(--font-size-h3)",
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: 0.02,
  },
  h4: {
    fontSize: "var(--font-size-h4)",
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: 0.02,
  },
  h5: {
    fontSize: "var(--font-size-h5)",
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: 0.02,
  },
  h6: {
    fontSize: "var(--font-size-h6)",
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: 0.02,
  },
  subtitle1: {
    fontSize: "var(--font-size-xl)",
    fontWeight: 500,
    lineHeight: 1.45,
    letterSpacing: 0,
  },
  subtitle2: {
    fontSize: "var(--font-size-m)",
    fontWeight: 500,
    lineHeight: 1.45,
    letterSpacing: 0,
  },
  caption: {
    fontSize: "var(--font-size-xs)",
    fontWeight: 600,
    lineHeight: "var(--base-line-height)",
    textTransform: "uppercase",
    letterSpacing: 0.1,
  },
  body1: {
    fontSize: "var(--font-size-l)",
    lineHeight: "var(--base-line-height)",
    letterSpacing: 0,
    color: "inherit",
  },
  body2: {
    fontSize: "var(--font-size-m)",
    fontWeight: "inherit",
    lineHeight: "var(--base-line-height)",
    color: "inherit",
  },
  button: {
    fontSize: "var(--font-size-m)",
    fontWeight: 600,
    lineHeight: "var(--base-line-height)",
    letterSpacing: 0.02,
  },
};

export const MuiTypography: Components["MuiTypography"] = {
  defaultProps: {
    variantMapping: {
      h1: "h1",
      h2: "h2",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      h6: "h6",
      subtitle1: "h3",
      subtitle2: "h4",
      body1: "span",
      body2: "span",
    },
  },
};
